import { useMutation } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";

export const ReassignRoleContext = createContext(null);

type Props = {
  children: ReactElement;
};

const ReassignRoleProvider: FunctionComponent<Props> = ({ children }) => {
  const { mutateAsync, data, isPending, error } = useMutation({
    mutationFn: async (payload) => {
      const data = await Api.put("settings/members/assign-role", payload);
      return data;
    },
    onError: (err) => {
      throw err;
    },
  });

  const contextValue = useMemo(
    () => ({
      mutateAsync,
      data,
      error,
      isPending,
    }),
    [mutateAsync, data, error, isPending],
  );
  return (
    <ReassignRoleContext.Provider value={contextValue}>
      {children}
    </ReassignRoleContext.Provider>
  );
};

export default ReassignRoleProvider;
